<!--白名单详情-->
<template>
  <div class="white-list-details">
    <div class="header">
      <div class="back" @click="goBack"><i class="iconfont icon-fanhui" style="font-size: 24px;"></i></div>
      白名单-详情
    </div>
    <div v-if="infoData.orderNo" class="info-title">
      <div>{{ infoData.orderNo }} + {{ infoData.productName }}({{ infoData.productId }})</div>
      <div>{{ infoData.orderDescription }}</div>
    </div>
    <el-form :inline="true" class="search-form">
      <el-form-item label="状态">
        <el-select v-model="searchForm.status" filterable placeholder="请选择" clearable style="width: 100px;">
          <el-option
            v-for="item in statusList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Mac码">
        <el-input v-model="searchForm.deviceIdentification" placeholder="请输入Mac码" clearable>
        </el-input>
      </el-form-item>
      <el-button class="btn" type="primary" size="14" @click="getList()">查询</el-button>
    </el-form>
    <div class="search">
      <div class="num-title">总数量：{{ infoData.totalAmount }}，已使用：{{ infoData.usageAmount }}</div>
      <div>
        <el-button type="primary" :disabled="!multipleSelection.length" size="14" @click="handleExport">导出白名单</el-button>
        <el-button v-if="showBtn" type="add" size="14" class="generate" @click="handleGenerate">导入白名单</el-button>
      </div>
    </div>
    <el-table
      v-loading="loading"
      :data="tableData"
      style="width: 100%"
      size="medium"
      :header-cell-style="{ background: '#F5F6F7' }"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        width="55">
      </el-table-column>
      <el-table-column label="设备标识 (Mac码)">
        <template slot-scope="scope">
          {{ scope.row.deviceIdentification || "-" }}
        </template>
      </el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">
          {{ scope.row.status === 1 ? '已使用' : "未使用" }}
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="operate"
            :disabled="scope.row.status === 1"
            @click="handleDelete(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="currentPage"
      :page-sizes="[10, 20, 50]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange">
    </el-pagination>
    <el-dialog
      title="上传白名单文件"
      :visible.sync="dialogVisible"
      width="596px"
      :before-close="handleClose"
      custom-class="white-list-dialog">
      <el-form
        ref="form"
        :model="formInfo"
        :rules="rules"
        width="596px"
        label-width="80px"
        label-position="right">
        <el-form-item label="文件导入" prop="file">
          <el-upload
            class="upload-demo"
            action="mqtt/device/identification/import"
            :headers="headers"
            :before-upload="beforeUpload"
            :on-success="uploadSuccess"
            :on-error="uploadError"
            multiple
            :accept="uploadFileType">
            <el-button v-if="!uploadSuccessedFile" size="small" icon="el-icon-plus" class="upload-btn">上传文件</el-button>
            <el-input v-else v-model="formInfo.fileName" class="file-name">{{ formInfo.fileName }}</el-input>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button size="small" class="download-btn" @click="handleDownload">
            <span class="text">模版文件下载</span>
            <span>白名单.csv</span>
          </el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="14" @click="handleClose">取消</el-button>
        <el-button type="primary" size="14" @click="onsubmit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import store from '@/store'
import { detailsList, exports, saveFile, deleteIdentification, detailsInfo, template } from '@/api/device-identity-auth/white-list'
export default {
  name: 'tripletDetails',
  data() {
    return {
      headers: {
        'TENANT-ID': store.getters.userInfo.tenantId,
        Authorization: 'Bearer ' + store.getters.access_token,
        id: this.id
      },
      tableData: [], // 列表数据
      infoData: {}, // 信息数据
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页条数
      total: 0, // 列表数据总条数
      loading: true,
      searchForm: {
        status: '', // 状态
        deviceIdentification: '' // deviceIdentification
      },
      multipleSelection: [], // 多选数据
      statusList: [
        { label: '全部', value: '' },
        { label: '已使用', value: 1 },
        { label: '未使用', value: 0 }
      ],
      dialogVisible: false,
      uploadSuccessedFile: false,
      fileList: [], // 上传的固件文件
      uploadSuccessOrError: false, // 上传固件成功则展示固件基本信息否则不展示
      uploadFileType: 'csv', // 文件类型
      rules: {
        file: { required: true, validator: this.validateFile, trigger: 'blur' }
      },
      id: '',
      formInfo: {
        fileName: '', // 上传成功的csv文件名称
        fileUrl: '' // 上传成功的csv文件URL
      }
    }
  },
  computed: {
    showBtn() {
      let flag = false
      if (process.env.VUE_APP_BASE_URL === 'https://smart.miligc.com/') {
        flag = true
      } else {
        flag = false
      }
      return flag
    }
  },
  created() {
    this.id = this.$route.query.id
    this.getList()
    this.getInfo()
  },
  methods: {
    // 上传白名单校验
    validateFile(rule, value, callback) {
      if (this.fileList.length === 0) {
        callback(new Error('请上传文件'))
      } else {
        callback()
      }
    },
    // 所需数量校验
    validateNumber(rule, value, callback) {
      const flag = new RegExp(/^(?:[1-9][0-9]{0,4}|100000)$/).test(value)
      if (!flag) {
        callback(new Error('请输入1-10w内的数字'))
      } else {
        callback()
      }
    },
    // 信息数据
    getInfo() {
      const params = {
        id: this.id
      }
      detailsInfo(params).then(res => {
        this.infoData = res.data.data
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    /**
     * 详情列表
     */
    getList() {
      this.loading = true
      // 过滤 searchForm 中值为空的属性
      const filteredSearchForm = {}
      for (const key in this.searchForm) {
        if (this.searchForm[key] !== '') {
          filteredSearchForm[key] = this.searchForm[key]
        }
      }
      const params = {
        deviceWhiteListId: this.id,
        size: this.pageSize,
        current: this.currentPage,
        ...filteredSearchForm
      }
      detailsList(params).then(res => {
        this.tableData = res.data.data.records
        this.total = res.data.data.total
      }).catch(err => {
        this.$message.error(err.message)
      }).finally(() => {
        this.loading = false
      })
    },
    // 返回
    goBack() {
      this.$router.push({
        path: '/device-identity-auth/white-list/index'
      })
    },
    // 全选/多选
    handleSelectionChange(val) {
      this.multipleSelection = val.map(item => item.id)
    },
    // 导出白名单
    handleExport() {
      const params = {
        idList: this.multipleSelection
      }
      exports(params).then(res => {
        this.exportBlobFile(res)
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // csv模板下载
    handleDownload() {
      template().then(res => {
        this.downBlobFile(res.data.data, {}, '白名单')
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 导出白名单弹窗
    handleGenerate() {
      this.dialogVisible = true
    },
    // 保存导入的白名单
    onsubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const params = {
            fileUrl: this.formInfo.fileUrl,
            deviceWhiteListId: this.id
          }
          saveFile(params).then(res => {
            this.dialogVisible = false
            this.$refs['form'].resetFields()
            this.uploadSuccessedFile = false
            this.formInfo.fileName = ''
            this.formInfo.fileUrl = ''
            this.$message.success('导入成功')
            this.getList()
            this.getInfo()
          }).catch(err => {
            this.$message.error(err.message)
          })
        } else {
          return false
        }
      })
    },
    // 关闭上传白名单弹窗
    handleClose() {
      this.dialogVisible = false
      this.$refs['form'].resetFields()
      this.uploadSuccessedFile = false
      this.formInfo.fileName = ''
      this.formInfo.fileUrl = ''
      this.fileList = []
    },
    // 删除
    handleDelete(id) {
      const params = {
        id: id
      }
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteIdentification(params).then(res => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.getList()
          this.getInfo()
        }).catch(err => {
          this.$message.error(err.message)
        })
      }).catch(err => {})
    },
    // 每页条数改变时触发
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    // 当前页变时触发
    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    },
    // 上传之前做校验
    beforeUpload(file) {
      // 在上传之前检查文件类型
      const extension = file.name.split('.').pop() // 获取上传文件的扩展名
      const allowedExtensions = this.uploadFileType

      if (!allowedExtensions.includes(extension)) {
        this.$message.error('请使用正确的模板')
        return false // 阻止文件上传
      }

      return true // 允许文件上传
    },
    // 文件上传成功
    uploadSuccess(res, file, fileList) {
      if (res.code === 0) {
        this.fileList = file
        this.formInfo.fileName = res.data.fileName
        this.formInfo.fileUrl = res.data.fileUrl
        this.uploadSuccessedFile = true
      } else {
        this.$message.error(res.msg)
      }
    },
    // 文件上传失败
    uploadError(err, file, fileList) {
      this.$message.error(err)
    }
  }
}
</script>
<style lang="scss" scoped>
.white-list-details {
  .header {
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: 800;

    .back {
      cursor: pointer;
      margin-right: 8px;
    }
  }

  .info-title {
    font-size: 16px;
    margin: 10px 0;
    padding: 10px;
    width: max-content;
    background: rgba(39, 95, 232, 0.1);
  }

  .search-form {
    margin-top: 20px;
    .btn {
      float: right;
    }
  }

  .search {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
    margin-bottom: 24px;

    .num-title {
      width: max-content;
      background: rgba(39, 95, 232, 0.1);
      padding: 10px;
      color: #252525;
      font-size: 18px;
    }

    .generate {
      margin-left: 20px;
    }
  }

  .order-desc {
    margin-bottom: 12px;
    font-size: 18px;
    font-weight: 400;
    color: #252525;
  }

  .download-btn {
    background: rgba(39,95,232,0.1);
    border-radius: 4px;
    border: 1px solid #DEDEDE;
    width: 100%;
    height: 32px;
    font-weight: 400;
    color: #275FE8;
    margin-top: 8px;
    font-size: 14px;

    .text {
      margin-right: 24px;
    }
  }
}

::v-deep .upload-demo {
  .el-upload {
    width: 100%;
  }
  .upload-btn,
  .file-name {
    width: 100%;
    color: #275FE8;
    font-size: 14px;
    height: 32px;

    ::v-deep .el-input__inner {
      color: #275FE8;
    }
  }

  .el-upload-list {
    display: none;
  }

  .el-button {
    width: 100%;
    color: #275fe8;
  }
}
</style>
